import { ThemeIconSizeVariable as e } from "../../theme/theme-types.js";
const o = {
  lg: e.Medium,
  md: e.Medium,
  sm: e.Small
};
function a(r) {
  if (typeof r == "string")
    return o[r];
  if (Array.isArray(r))
    return r.map((t) => t && o[t]);
  if (typeof r == "object") {
    const t = {};
    return Object.keys(r).forEach((n) => {
      const i = r[n];
      i && (t[n] = o[i]);
    }), t;
  }
}
export {
  a as getIconSizeFromButtonSize,
  o as iconSizeMap
};
